import React, { Fragment, useEffect, useState } from 'react'
import { Badge, Button, Image } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'

import { getTitulosPaginas } from './components/BreadCrumbs/tituloPaginas'
import ColetaClickstream from './components/clickstreamAnalise/clickstreamColeta.js'
import InfoUsuario from './components/componentesModais/infoUsuario'
import { RenderMensagemInformacao } from './components/componentesModais/mensagens/mensagemInformacao.js'
import Icone from './components/Icone/index.jsx'
import Tutoriais from './components/painelTutoriais/painelTutoriais'
import AlterarLogin from './components/perfilUsuario/alterarLogin'
import AlterarSenha from './components/perfilUsuario/alterarSenha/index.jsx'
import DadosConta from './components/perfilUsuario/dadosConta'
import PerfilUsuario from './components/perfilUsuario/perfil'
import ModalDetalhesVersao from './components/releaseNotes/ModalDetalhesVersao'
import { api_gateway } from './conexoes/api'
import './css/navegacaoSistema.css'
import {
  conteudoBusca,
  expandirNavegacao,
  expandirNavegacaoHover,
  imagemPerfil,
  limpouBusca,
  mudarBreadCrumbs,
  mudarManejador,
  mudarPermissaoElemento,
  mudarPermissaoElementoAcao,
  mudarPermissaoElementoOutrosConfiguracoesConfigurarGrupos,
  mudarPermissaoElementoOutrosConfiguracoesExibirColunas,
  mudarPermissaoElementoOutrosInformacoesConsultarCobertura,
  mudarPermissaoElementoOutrosMensagensVisualizarMensagens,
  revelarTutorial
} from './redux/actions/index'
import { setaMenuLateral } from './utils/alternanciaIcones'
import decryptJWT from './utils/decryptJWT'
import utilsLocalStorage from './utils/localStorage'
import { isPortal } from './utils/nivelCliente.js'
import { validadorPermissaoElemento } from './utils/verificadorPermissaoElemento'

const clientesSemChat = ['600000', '410656']
const img_nav_1 =
  'https://veye.s3.sa-east-1.amazonaws.com/icones/virtueyesSimbolo.svg'

const iconesMap = {
  dispositivos: 'dispositivos',
  admin: 'admin',
  manutencao: 'manutencao',
  virtueyes: 'icone-olho-ligado',
  financeiro: 'financeiro',
  pedidos: 'pedidos',
  sms: 'sms',
  clientes: 'clientes',
  dashboard: 'dashboard',
  usuarios: 'usuarios',
  automacao: 'automacao',
  relatorios: 'relatorios',
  faturas: 'icone-fatura',
  cadastros: 'cadastros',
  solicitacoes: 'solicitacoes',
  fornecedores: 'fornecedor',
  info: 'informacoes',
  'simcards-virgens': 'simcard-vigem',
  portadoras: 'cell-tower',
  'e-sim': 'e-sim'
}

function renderIcones(icone) {
  return iconesMap[icone] || false
}

function ContainerModalAcao({ children }) {
  return (
    <div className="componente-modal-overlay">
      <div className="componente-modal">{children}</div>
    </div>
  )
}

const IconeTextoTela = ({ tela, telaAtiva, SpanMenuTexto, idTela }) => (
  <Fragment key={idTela}>
    <Icone
      className="float-left icone-menu-filho"
      width="11px"
      height="11px"
      nome={telaAtiva === tela.rota ? 'elipse-preenchida' : 'elipse'}
      color={telaAtiva === tela.rota ? 'primary' : 'default'}
    />
    <SpanMenuTexto tela={tela} telaAtiva={telaAtiva} />
  </Fragment>
)

const SpanX = ({ toRoute, idElementoCor, classModuloDiv, modulo }) => (
  <span
    to={toRoute}
    className={
      idElementoCor === classModuloDiv
        ? 'col menu-selecionado float-left'
        : 'col menu-texto float-left'
    }
  >
    {modulo.label}
  </span>
)

const RedBadge = () => (
  <Badge variant="danger" className="badge-novidade-menu-lateral">
    !
  </Badge>
)

const SpanMenuTexto = ({ tela, telaAtiva }) => (
  <span
    className={
      telaAtiva == tela.rota
        ? 'col menu-texto-selecionado fonte-cor-2 float-left'
        : 'col menu-texto menu-selecionado float-left'
    }
  >
    {tela.label}
  </span>
)

const Images = ({ modulo, idElementoCor, classModuloDiv, toRoute }) => (
  <Fragment key={modulo.icone}>
    <Icone
      className="icones-navegacao-sistema"
      width="23px"
      height="23px"
      nome={renderIcones(modulo.icone)}
      color={idElementoCor === classModuloDiv ? 'primary' : 'default'}
    />
    <SpanX
      toRoute={toRoute}
      idElementoCor={idElementoCor}
      classModuloDiv={classModuloDiv}
      modulo={modulo}
    />
  </Fragment>
)

const LinkPagina = ({
  tela,
  telaAtiva,
  idTela,
  permissaoConsultarCobertura,
  contadorNovidadesNaoLidas,
  handleRevelarModal,
  handleBeforeClick,
  SpanMenuTexto
}) => {
  const rota = tela.rota
  const className =
    telaAtiva == rota
      ? 'mouse-hover menu-expandido-item-filho-3  menu-expandido-item-filho row nao-selecionavel menu-expandido-item-filho-borda'
      : 'mouse-hover menu-expandido-item-filho row nao-selecionavel'

  if (rota?.includes('http')) {
    // link externo
    if (!permissaoConsultarCobertura) return null

    const linkExterno = rota.replace('veye/', '')

    return (
      <a
        rel="noreferrer"
        key={idTela}
        href={linkExterno}
        target="_blank"
        className={className}
      >
        <IconeTextoTela
          tela={tela}
          telaAtiva={telaAtiva}
          SpanMenuTexto={SpanMenuTexto}
          idTela={idTela}
        />
      </a>
    )
  } else if (rota?.includes('veye/info')) {
    // Informações
    return (
      <div
        key={idTela}
        onClick={() => handleRevelarModal(rota)}
        className={className}
      >
        <IconeTextoTela
          tela={tela}
          telaAtiva={telaAtiva}
          SpanMenuTexto={SpanMenuTexto}
          idTela={idTela}
        />
        {contadorNovidadesNaoLidas > 0 && rota?.includes('Novidade') && (
          <RedBadge />
        )}
      </div>
    )
  } else {
    return (
      // tela normal
      <NavLink
        key={idTela}
        onClick={() => handleBeforeClick(rota, tela.cdMenu, 'tela')}
        to={'/' + rota}
        className={className}
      >
        <IconeTextoTela
          tela={tela}
          telaAtiva={telaAtiva}
          SpanMenuTexto={SpanMenuTexto}
          idTela={idTela}
        />
      </NavLink>
    )
  }
}

function NavegacaoSistema(props) {
  const [revelarInfosUsuario, setRevelarInfosUsuario] = useState(false)
  const [menuExpandido, setMenuExpandido] = useState(true)
  const [menuBarraRecolhida, setMenuBarraRecolhida] = useState(false)
  const [telaAtiva, setTelaAtiva] = useState(
    window.location.href.split('/')[3] +
      '/' +
      window.location.href.split('/')[4] +
      '/' +
      window.location.href.split('/')[5]
  )
  const [telaFilhaAtiva, setTelaFilhaAtiva] = useState(
    window.location.href.split('/')[3] +
      '/' +
      window.location.href.split('/')[4] +
      '/' +
      window.location.href.split('/')[5]
  )
  const [elementosAtivos, setElementosAtivos] = useState(0)
  const [elementosAtivosCor, setElementosAtivosCor] = useState(0)
  const [idElementoCor, setIdElementoCor] = useState(0)
  const [arrayRenderModulos, setArrayRenderModulos] = useState([])
  const [renderizar, setRenderizar] = useState(false)
  const [revelarMenuReleaseNotes, setRevelarMenuReleaseNotes] = useState(false)
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [contadorNovidadesNaoLidas, setContadorNovidadesNaoLidas] = useState(0)

  const clienteNivel = decryptJWT('clienteNivel')

  const localTema = localStorage.getItem('tema')

  let imagem = useSelector((state) => state.manejadorState.imagemPerfil)
  const permissaoConsultarCobertura = useSelector(
    (state) =>
      state.permissaoState.permissaoElementoOutrosInformacoesConsultarCobertura
  )
  let revelarMenuTutorial = useSelector(
    (state) => state.manejadorState.revelarTutorial
  )
  let atualizarAlertaCabecalho = useSelector(
    (state) => state.mensagensState.atualizarAlertaCabecalho
  )

  const isModuloInformacoes = (modulo) => modulo.cdMenu === 427

  const manejador = useSelector((state) => state.manejadorState.manejador)

  const portalCliente = isPortal()

  const getFlChat = localStorage.getItem('fl_chat')
  const flChat = getFlChat === '1' && !portalCliente

  const codigoErpAntigo = decryptJWT('codigoClienteErpAntigo')

  const token = localStorage.getItem('@veye-Token')
  useEffect(() => {
    const chatElements = document.getElementsByClassName('smk-altu-button-chat')

    if (chatElements.length > 0) {
      Array.from(chatElements).forEach((chatElement) => {
        if (token && flChat && !clientesSemChat.includes(codigoErpAntigo)) {
          chatElement.style.display = 'block'
        } else {
          chatElement.style.display = 'none'
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, flChat])

  const despacho = useDispatch()
  let estadoExpansaoNavegacao = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  const menuLateralExpandido = estadoExpansaoNavegacao === true

  useEffect(() => {
    despacho(mudarPermissaoElementoAcao(false))
    despacho(expandirNavegacaoHover(menuExpandido))
  }, [despacho])

  function expandeMenu() {
    if (
      estadoExpansaoNavegacao === false &&
      menuExpandido === true &&
      menuBarraRecolhida === false
    ) {
      despacho(expandirNavegacao(!estadoExpansaoNavegacao))
      setMenuExpandido(false)
      setMenuBarraRecolhida(true)
    }
  }

  function recolheMenu() {
    if (
      menuLateralExpandido &&
      menuExpandido === false &&
      menuBarraRecolhida === true
    ) {
      despacho(expandirNavegacao(!estadoExpansaoNavegacao))
      setMenuExpandido(true)
      setMenuBarraRecolhida(false)
    }
  }

  function handleBeforeClick(telaAtiva, cdTelaAtiva, tela) {
    if (tela === 'modulo') {
      handleDropTelas('modulo-' + cdTelaAtiva, 'modulo')
    }
    if (tela === 'tela') {
      handleDropFilhoTelas('tela-' + cdTelaAtiva, telaAtiva, 'tela') // quando clica em uma tela dentro de um módulo
    }
    setTelaAtiva(telaAtiva)
    despacho(conteudoBusca(''))
    despacho(limpouBusca(true))
  }

  function handleBeforeClickTelaFilha(telaAtiva) {
    despacho(conteudoBusca(''))
    despacho(limpouBusca(true))
    despacho(mudarManejador(''))
    setTelaFilhaAtiva(telaAtiva)
  }

  useEffect(() => {
    async function renderModulo() {
      setRenderizar(false)
      let objetoTela = []
      let objetoTelaFilhos = []
      let objetoModulo = []

      if (
        imagem === '' ||
        imagem === null ||
        !utilsLocalStorage.getUsuarioNomeCompleto()
      ) {
        await api_gateway
          .get('/m1/consultar/usuario?cd_pav_usuario=' + decryptJWT('codigo'))
          .then((resolve) => {
            if (resolve.data.status === 200 && resolve.data.dados.length != 0) {
              const objDados = resolve.data.dados[0]
              utilsLocalStorage.setUsuarioNomeCompleto(objDados)
              if (objDados.bl_imagem != null && objDados.bl_imagem != '') {
                despacho(imagemPerfil(objDados.bl_imagem))
              }
            }
          })
          .catch(function (error) {
            console.error(error)
          })
      }

      const pegarMenus = await api_gateway.post(
        '/m1/servicos/dados/permissao',
        {
          id: decryptJWT('id')
        }
      )

      if (pegarMenus.data.dados) {
        despacho(mudarBreadCrumbs(getTitulosPaginas(pegarMenus.data.dados)))

        const elementos = JSON.parse(JSON.stringify(pegarMenus.data.dados[3]))
        despacho(mudarPermissaoElemento(elementos))

        despacho(
          mudarPermissaoElementoOutrosConfiguracoesExibirColunas(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/configuracoes/exibirColunas'
            )
          )
        )
        despacho(
          mudarPermissaoElementoOutrosConfiguracoesConfigurarGrupos(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/configuracoes/configurarGrupos'
            )
          )
        )
        despacho(
          mudarPermissaoElementoOutrosInformacoesConsultarCobertura(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/informacoes/consultarCobertura'
            )
          )
        )
        despacho(
          mudarPermissaoElementoOutrosMensagensVisualizarMensagens(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/mensagens/visualizarMensagens'
            )
          )
        )
      }

      function renderTelaFilho(cdTela) {
        objetoTelaFilhos = pegarMenus.data.dados[2]
          .filter(
            (tela) => tela.menuPai == cdTela && tela.n0_nivel >= clienteNivel
          )
          .map((tela) => {
            const key = 'telaFilha-' + tela.cdMenu
            return (
              <CSSTransition
                timeout={500}
                classNames="my-node"
                in={false}
                key={key}
              >
                <li key={key}>
                  <NavLink
                    onClick={() => handleBeforeClickTelaFilha(tela.rota)}
                    to={'/' + tela.rota}
                    className={
                      telaFilhaAtiva == tela.rota
                        ? 'menu-expandido-item-filho-3 menu-expandido-item-tela-filho row'
                        : 'menu-expandido-item-filho-2 menu-expandido-item-tela-filho row'
                    }
                  >
                    <Icone
                      className={
                        menuLateralExpandido
                          ? 'float-left icone-menu-tela-filho-1'
                          : 'float-left icone-menu-tela-filho-2'
                      }
                      width="11px"
                      height="11px"
                      nome={
                        telaFilhaAtiva == tela.rota
                          ? 'elipse-preenchida'
                          : 'elipse'
                      }
                      color={
                        telaFilhaAtiva == tela.rota ? 'primary' : 'default'
                      }
                    />
                    <span
                      className={
                        telaFilhaAtiva == tela.rota
                          ? 'col menu-texto-selecionado fonte-cor-2 float-left'
                          : 'col menu-texto menu-selecionado float-left'
                      }
                    >
                      {tela.label}
                    </span>
                  </NavLink>
                </li>
              </CSSTransition>
            )
          })
        return objetoTelaFilhos
      }

      function handleRevelarModal(rota) {
        const auxAcaoMostrarModal = rota.replace('veye/info/', '')
        switch (auxAcaoMostrarModal) {
          case 'revelarModalTutoriais':
            despacho(revelarTutorial(true))
            break
          case 'revelarModalFAQ':
            handleMensagemInformacao(false)
            break
          case 'revelarModalNovidades':
            revelarModalNovidades()
            break
          default:
            break
        }
      }

      function revelarModalNovidades() {
        setRevelarMenuReleaseNotes(true)
      }

      function renderTela(cdModulo) {
        objetoTela = pegarMenus.data.dados[2]
          .filter(
            (tela) => tela.menuPai == cdModulo && tela.n0_nivel >= clienteNivel
          )
          .map((tela) => {
            const idTela = 'tela-' + tela.cdMenu

            return (
              <CSSTransition
                timeout={500}
                classNames="my-node"
                in={false}
                key={idTela}
              >
                {tela.filho === 0 ? (
                  <li id={idTela} key={idTela}>
                    <LinkPagina
                      tela={tela}
                      telaAtiva={telaAtiva}
                      idTela={idTela}
                      permissaoConsultarCobertura={permissaoConsultarCobertura}
                      contadorNovidadesNaoLidas={contadorNovidadesNaoLidas}
                      handleRevelarModal={handleRevelarModal}
                      handleBeforeClick={handleBeforeClick}
                      SpanMenuTexto={SpanMenuTexto}
                    />
                  </li>
                ) : (
                  <li key={idTela}>
                    <div
                      className={
                        telaAtiva == tela.cdMenu
                          ? 'mouse-hover menu-expandido-item-filho row nao-selecionavel'
                          : 'mouse-hover menu-expandido-item-filho row nao-selecionavel'
                      }
                      onClick={() =>
                        handleDropFilhoTelas('tela-' + tela.cdMenu, tela.rota)
                      }
                    >
                      <Icone
                        className="icone-menu-filho"
                        width="11px"
                        height="11px"
                        nome={
                          telaAtiva === tela.rota
                            ? 'elipse-preenchida'
                            : 'elipse'
                        }
                        color={telaAtiva === tela.rota ? 'primary' : 'default'}
                      />
                      <SpanMenuTexto tela={tela} telaAtiva={telaAtiva} />
                      <Image
                        key="4"
                        id={tela.rota}
                        className="float-right icone-menu-com-filho fonte-cor-1 campo-select-icone-desativado"
                        src={setaMenuLateral()}
                      />
                    </div>
                    <ul id={idTela} className="dropdown-desativado-tela">
                      {renderTelaFilho(tela.cdMenu)}
                    </ul>
                  </li>
                )}
              </CSSTransition>
            )
          })
        return objetoTela
      }

      objetoModulo = pegarMenus.data.dados[1]
        .filter(
          (modulo) =>
            modulo.menuPai !== null &&
            modulo.cdMenu != 136 &&
            modulo.n0_nivel >= clienteNivel
        )
        .map((modulo) => {
          const strModulo = 'modulo-' + modulo.cdMenu
          const classModuloDiv = strModulo + '-div'

          const toRoute = '/' + modulo.rota

          const idNavLink = strModulo + '-div'
          const classNavLink = 'menu-expandido-item row nao-selecionavel'

          if (isModuloInformacoes(modulo) && portalCliente) return null

          return (
            <Fragment key={strModulo}>
              {modulo.filho === 0 ? (
                <li key={strModulo}>
                  <NavLink
                    id={idNavLink}
                    onClick={() =>
                      handleBeforeClick(modulo.rota, modulo.cdMenu, 'modulo')
                    }
                    to={toRoute}
                    className={classNavLink}
                  >
                    <Images
                      modulo={modulo}
                      idElementoCor={idElementoCor}
                      classModuloDiv={classModuloDiv}
                      toRoute={toRoute}
                    />
                  </NavLink>
                </li>
              ) : (
                <li key={strModulo}>
                  {modulo.acionar === 0 ? (
                    <div
                      id={idNavLink}
                      className={classNavLink}
                      onClick={() => handleDropTelas(strModulo)}
                    >
                      <Images
                        modulo={modulo}
                        idElementoCor={idElementoCor}
                        classModuloDiv={classModuloDiv}
                        toRoute={toRoute}
                      />

                      {isModuloInformacoes(modulo) &&
                        contadorNovidadesNaoLidas > 0 && <RedBadge />}
                    </div>
                  ) : (
                    <NavLink
                      id={idNavLink}
                      onClick={() => {
                        handleBeforeClick(modulo.rota, modulo.cdMenu, 'modulo')
                        handleDropTelas(strModulo)
                      }}
                      to={toRoute}
                      className={classNavLink}
                    >
                      <Images
                        modulo={modulo}
                        idElementoCor={idElementoCor}
                        classModuloDiv={classModuloDiv}
                        toRoute={toRoute}
                      />
                    </NavLink>
                  )}
                  <ul
                    id={strModulo}
                    className="dropdown-desativado nao-selecionavel"
                  >
                    {renderTela(modulo.cdMenu)}
                  </ul>
                </li>
              )}
            </Fragment>
          )
        })

      setArrayRenderModulos(objetoModulo)
    }
    renderModulo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderizar, localTema, estadoExpansaoNavegacao])

  function escondeDropdown(el) {
    ColetaClickstream(934) // 'cabecalhoSistemaEscondeDropdown'
    el.classList.remove('dropdown-ativado')
    el.classList.add('dropdown-desativado')
  }

  function escondeDropdownTela(el) {
    ColetaClickstream(935) // 'cabecalhoSistemaEscondeDropdownTela'
    el.classList.remove('dropdown-ativado-tela')
    el.classList.add('dropdown-desativado-tela')
  }

  function removerCorAtivado(el) {
    el.classList.remove('dropdown-ativado-cor')
  }

  useEffect(() => {
    if (idElementoCor) {
      let divCor = document.getElementById(idElementoCor)
      divCor.classList.add('dropdown-ativado-cor')
    }
    if (elementosAtivosCor.length > 0) {
      elementosAtivosCor.forEach(removerCorAtivado)
    }
    if (elementosAtivos.length > 0) {
      elementosAtivos.forEach(escondeDropdown)
    }
  }, [idElementoCor, elementosAtivos, elementosAtivosCor])

  function handleMensagemInformacao() {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
    }
  }

  function handleDropTelas(elementoId, moduloTela) {
    ColetaClickstream(937) // 'navegacaoSistemaHandleDropTelas'
    let elemento = document.getElementById(elementoId)
    let elementosAtivos = document.querySelectorAll('.dropdown-ativado-tela')

    if (elementosAtivosCor.length > 0) {
      elementosAtivosCor.forEach(removerCorAtivado)
    }
    if (elementosAtivos.length > 0) {
      elementosAtivos.forEach(escondeDropdown)
    }

    setElementosAtivos(document.querySelectorAll('.dropdown-ativado'))
    setElementosAtivosCor(document.querySelectorAll('.dropdown-ativado-cor'))
    setIdElementoCor(elementoId + '-div')

    if (moduloTela === undefined) {
      elemento.classList.toggle('dropdown-ativado')
    }

    if (moduloTela != undefined) {
      handleDropFilhoTelas(elementoId, moduloTela, moduloTela)
    }
  }

  function handleDropFilhoTelas(elementoId, telaAtiva, tela) {
    setTelaAtiva(telaAtiva)
    let elementosAtivos = document.querySelectorAll('.dropdown-ativado-tela')
    let imagemClasses = document.querySelectorAll('.campo-select-icone-ativado')

    let elemento = document.getElementById(elementoId)
    let imagem = document.getElementById(telaAtiva)

    if (tela == undefined) {
      elemento.classList.toggle('dropdown-ativado-tela')

      if (elemento.classList.contains('dropdown-desativado-tela')) {
        elementosAtivos.forEach((item) =>
          item.classList.toggle('dropdown-desativado-tela')
        )
        elementosAtivos.forEach((item) =>
          item.classList.toggle('dropdown-ativado-tela')
        )
        imagem.classList.toggle('campo-select-icone-desativado')
        imagem.classList.toggle('campo-select-icone-ativado')
      }
    } else {
      setTelaFilhaAtiva('')
      imagemClasses.forEach((item) =>
        item.classList.toggle('campo-select-icone-desativado')
      )
      imagemClasses.forEach((item) =>
        item.classList.toggle('campo-select-icone-ativado')
      )
    }
    if (elementosAtivos.length > 0) {
      elementosAtivos.forEach(escondeDropdownTela)
    }
  }

  useEffect(() => {
    async function handleCarregarPermissoes() {}
    handleCarregarPermissoes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!manejador) return
    buscaNovidadesNaoLidas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manejador, atualizarAlertaCabecalho])

  async function buscaNovidadesNaoLidas() {
    // TODO: Como o 'Informações' foi movido para o menu lateral,
    // verificar se faz sentido mover isso também + useEffect acima para "navegacaoSistema.js"

    const { data } = await api_gateway.get(
      '/m1/consultar/usuario_versionamento'
    )
    let lastReleaseNoteRead
    let lastReleaseNotes

    if (data?.status == 200) {
      const auxDadosNovidades = data?.dados
      if (auxDadosNovidades.length > 0) {
        const ultimaNovidade = auxDadosNovidades[0]
        lastReleaseNoteRead = ultimaNovidade.cd_pav_release_ultima_lida
        lastReleaseNotes = ultimaNovidade.cd_pav_release
        localStorage.setItem(
          'releaseNotes',
          JSON.stringify({ lastReleaseNotes, lastReleaseNoteRead })
        )
      }

      if (lastReleaseNotes > lastReleaseNoteRead) {
        setContadorNovidadesNaoLidas(auxDadosNovidades?.length) // mostrar alerta
      } else {
        // não mostrar alertas
        if (contadorNovidadesNaoLidas > 0) {
          setContadorNovidadesNaoLidas(0)
        }
      }
    }
  }

  return (
    <div className="fundo-cor-5">
      {props.revelarDadosContaUsuario && (
        <ContainerModalAcao>
          <DadosConta />
        </ContainerModalAcao>
      )}
      {props.revelarPerfilContaUsuario && (
        <ContainerModalAcao>
          <PerfilUsuario />
        </ContainerModalAcao>
      )}
      {props.revelarAlterarLogin && (
        <ContainerModalAcao>
          <AlterarLogin />
        </ContainerModalAcao>
      )}
      {props.revelarAlterarSenha && <AlterarSenha />}

      {revelarMensagemInformacao && (
        <RenderMensagemInformacao
          handleMensagemInformacao={handleMensagemInformacao}
          mensagemParagrafo1="Caro cliente, para melhor atende-lo, nosso FAQ está em processo de contrução, em breve teremos mais novidades."
          mensagemBotao="FECHAR"
        />
      )}

      {revelarMenuTutorial === true && (
        <div className="componente-modal-overlay-tutorial">
          <div className="componente-modal">
            <Tutoriais />
          </div>
        </div>
      )}

      {revelarMenuReleaseNotes === true && (
        <div className="componente-modal-overlay-novidades">
          <div className="componente-modal">
            <ModalDetalhesVersao
              setRevelarMenuReleaseNotes={setRevelarMenuReleaseNotes}
            />
          </div>
        </div>
      )}

      <div
        className={
          menuLateralExpandido
            ? 'container-navegacao-sistema-1'
            : 'container-navegacao-sistema-2'
        }
      >
        <nav
          className="nav"
          onMouseEnter={() => expandeMenu()}
          onMouseLeave={() => recolheMenu()}
        >
          <Link to="/">
            <div className="container-logo-veye">
              <img
                alt="logo-vityueyes"
                className={
                  menuLateralExpandido
                    ? 'logo-virtueyes-simbolo-1'
                    : 'logo-virtueyes-simbolo-2'
                }
                src={img_nav_1}
              />
              <Icone
                width="50%"
                height="40px"
                nome="virtueyes"
                className={
                  menuLateralExpandido
                    ? 'logo-virtueyes-palavra-1'
                    : 'logo-virtueyes-palavra-2'
                }
              />
            </div>
          </Link>
          <div
            className={
              menuLateralExpandido
                ? 'container-usuario-logado'
                : 'container-usuario-logado-2'
            }
          >
            {imagem != null && imagem != '' ? (
              <IconeUsuarioLogado
                src={imagem}
                menuLateralExpandido={menuLateralExpandido}
              />
            ) : (
              <IconeUsuarioLogado
                src="https://jazzaero.com.br/wp-content/uploads/2017/05/default-placeholder-profile-icon-avatar-gray-woman-90197997.jpg"
                alt="perfil"
                menuLateralExpandido={menuLateralExpandido}
              />
            )}
            <div
              className={
                menuLateralExpandido
                  ? 'container-dropdown-perfil-cabecalho-sistema'
                  : 'container-dropdown-perfil-cabecalho-sistema-2'
              }
            />
            <div
              className={
                menuLateralExpandido
                  ? 'container-usuario-logado-dados'
                  : 'container-usuario-logado-dados-2'
              }
            >
              <div
                className={
                  menuLateralExpandido
                    ? 'usuario-logado-dados-nome-1'
                    : 'usuario-logado-dados-nome-2'
                }
              >
                <div className="fonte-cor-1">{decryptJWT('nomeDeUsuario')}</div>
              </div>
              <p
                className={
                  menuLateralExpandido
                    ? 'usuario-logado-dados-email-1'
                    : 'usuario-logado-dados-email-2'
                }
              >
                {decryptJWT('email')}
              </p>
            </div>
            {revelarInfosUsuario === false && (
              <Button
                className={
                  menuLateralExpandido
                    ? 'botao-expandir-infos-usuario'
                    : 'botao-expandir-infos-usuario-2'
                }
                onClick={() => setRevelarInfosUsuario(true)}
              >
                <Icone
                  width="14px"
                  height="14px"
                  nome="icone-seta-dropdown"
                  className="icone-botao-expandir-infos-usuario-desativado"
                />
              </Button>
            )}
            {revelarInfosUsuario === true && (
              <InfoUsuario setRevelarInfosUsuario={setRevelarInfosUsuario} />
            )}
          </div>
          <div
            className={
              menuLateralExpandido
                ? 'container-menus-navegacao'
                : 'container-menus-navegacao-1'
            }
          >
            <ul
              className="menu-links"
              onClick={() => setRenderizar(!renderizar)}
            >
              {arrayRenderModulos}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  )
}

const IconeUsuarioLogado = ({ menuLateralExpandido, src, alt = '' }) => (
  <img
    className={
      menuLateralExpandido ? 'icone-usuario-logado-1' : 'icone-usuario-logado-2'
    }
    src={src}
    alt={alt}
  />
)

function mapStateToProps(state) {
  return {
    revelarDadosContaUsuario: state.virtueyesState.revelarDadosContaUsuario,
    revelarPerfilContaUsuario: state.virtueyesState.revelarPerfilContaUsuario,
    revelarAlterarLogin: state.virtueyesState.revelarAlterarLogin,
    revelarAlterarSenha: state.virtueyesState.revelarAlterarSenha
  }
}

export default connect(mapStateToProps)(NavegacaoSistema)
